import { threatCards, landingpagetext } from "src/data/aiOptOut";
import RedactoAdvice from "./redacto-advice/redactoadvice";
import RedactText from "./optout-general-components/redacttext";
import ThreatCard from "./cards/threatcard";
import Image from "next/image";

const OptOutInfo = () => {
  return (
    <>
      <div className="flex w-full items-end justify-center mt-20">
        <RedactoAdvice
          redactoTitle={landingpagetext.RedactoWoopsieTitle}
          redactoText={landingpagetext.RedactoWoopsieText}
          imagePath={landingpagetext.RedactoImagePath}
          isButtonVisible={false}
        />
      </div>
      <div className="flex w-full items-end justify-center mt-20">
        <div className="text-center w-[350px] sm:w-full">
          <RedactText
            color="text-redactWhite font-bold font-sans"
            size="sm:text-[51px] text-[40px]"
            text={landingpagetext.AIThreatsTitle}
          />
        </div>
      </div>
      <div className="flex w-full items-end justify-center mt-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {threatCards.map((card) => {
            return (
              <ThreatCard
                key={card.Title}
                title={card.Title}
                imagePath={card.ImagePath.toString()}
                description={card.Description}
              />
            );
          })}
        </div>
      </div>
      <div className="flex w-full items-end justify-center mt-20 ">
        <RedactoAdvice
          redactoTitle={landingpagetext.RedactoProtectTitle}
          redactoText={landingpagetext.RedactoProtectText}
          imagePath={landingpagetext.RedactoProtectImagePath}
          isButtonVisible={true}
        />
      </div>
      <div className="flex w-full items-end justify-center mt-20">
        <div className="text-center w-[350px] sm:w-full">
          <RedactText
            color="text-redactWhite font-bold font-sans"
            size="sm:text-[51px] text-[35px]"
            text={landingpagetext.DeleteDigitalFootprintTitle}
          />
        </div>
      </div>
      <div className="flex w-full items-end justify-center mt-6 ">
        <div className="w-[350px] sm:w-[1000px] text-center">
          <RedactText
            color="text-gray-300"
            size="text-[18px]"
            text={`${landingpagetext.DeleteDigitalFoorprintText}`}
          />
        </div>
      </div>

      <div className="flex xl:flex-nowrap flex-wrap-reverse items-end justify-center mt-20 w-full">
        <ul className="list-none w-[320px] list-outside">
          <li className="flex flex-row gap-x-1 text-redactWhite font-bold text-[22px] py-3 ">
            <div className="bg-brand-purple w-1.5 h-6 mt-0.5" />
            {landingpagetext.ListDeleteSocialNetworkTitle}
          </li>
          <RedactText
            color="text-gray-300"
            size="text-[16px]"
            text={`${landingpagetext.ListDeleteSocialNetworkDescription}`}
          />

          <li className="flex flex-row gap-x-1 text-redactWhite font-bold text-[22px] py-3 mt-14">
            <div className="bg-brand-purple w-1.5 h-6 mt-0.5" />
            {landingpagetext.ListDeleteVariousContentTitle}
          </li>
          <RedactText
            color="text-gray-300"
            size="text-[16px]"
            text={`${landingpagetext.ListDeleteVariousContentDescription}`}
          />

          <li className="flex flex-row gap-x-1 text-redactWhite font-bold text-[22px] py-3 mt-14">
            <div className="bg-brand-purple w-1.5 h-6 mt-0.5" />
            {landingpagetext.ListScheduledDeletionTitle}
          </li>
          <RedactText
            color="text-gray-300"
            size="text-[16px]"
            text={`${landingpagetext.ListScheduledDeletionDescription}`}
          />
        </ul>
        <div className="w-24" />
        <Image
          src={require("/public/images/aiOptOut/common/redact-flow-chart.svg")}
          alt="Redact Logo"
          className=""
          width={600}
          height={0}
          priority
        />
      </div>
    </>
  );
};

export default OptOutInfo;
